
import { Component, Mixins, Watch } from 'vue-property-decorator';
import Content from '@/features/dashboard/components/widgets/transitStatus/Content.vue';
import PieChartSkeleton from '@/features/dashboard/components/widgets/PieChartSkeleton.vue';
import { getTransitStatusData } from '@/features/dashboard/services/dashboard.services';
import eventBus from '@/features/common/eventBus';
import eventNames from '@/features/common/constants/events';
import { TransitStatusWidget } from '@/features/dashboard/types';
import { WidgetMixin } from '../widgetMixin';

@Component({
  components: {
    Content,
    PieChartSkeleton,
  },
})
export default class TransitStatus extends Mixins(WidgetMixin) {
  private isLoading = true;

  get isDashboardSettingsLoaded(): number {
    return this.$store.getters.getIsDashboardSettings;
  }

  get widget(): TransitStatusWidget {
    return this.$store.getters.getWidgets.transitStatus;
  }

  @Watch('isDashboardSettingsLoaded', { immediate: true })
  private loadTransitStatus(newValue: number) {
    if (!newValue) return;
    this.updateWidgetData();
  }

  private async updateWidgetData(): Promise<void> {
    this.isLoading = true;
    this.rerenderWidget();

    const transitStatusData = await getTransitStatusData();
    this.$store.commit('setTransitStatus', transitStatusData);

    this.isLoading = false;
    this.rerenderWidget();
    eventBus.$emit(eventNames.DASHBOARD_WIDGET_DATA_LOADED);
  }

  private handleApply(widgetName: string) {
    this.apply('small');

    this.$store.dispatch('syncDashboardSetting', {
      dashboardWidget: widgetName,
      visible: true,
      position: this.currentPosition,
      itemsShown: 0,
      customSettings: null,
    });

    if (this.position !== this.currentPosition) {
      this.$store.dispatch('patchDashboardSetting', { size: 'small' });
      eventBus.$emit(eventNames.SORT_DASHBOARD_WIDGETS_POSITION, 'small');
    }
  }
}
